/* istanbul ignore file */
// ignore this file because setUserId(undefined) always gives a false positive missing coverage issue
import * as amplitude from "@amplitude/analytics-browser";

export function clearAmplitudeUserId() {
  amplitude.setUserId(undefined);
}
